import type { MouseEvent } from "react";
import { useTranslation } from "react-i18next";
import { useAo3Site } from "@/hooks/ao3SiteContext";
import { ao3ScrollToSection } from "@/hooks/ao3ScrollToSection";
import { ao3Assets, ao3NavItems } from "@/mocks/ao3Home";

export default function Ao3Footer() {
  const { t } = useTranslation();
  const { config } = useAo3Site();

  const go = (e: MouseEvent, target: string) => {
    e.preventDefault();
    ao3ScrollToSection(target);
  };

  return (
    <footer className="w-full bg-primary-900 text-background-50 dark:bg-primary-100 dark:text-foreground-950">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-11 w-11 items-center justify-center overflow-hidden rounded-md bg-background-50">
                <img src={ao3Assets.logo} alt="AO3 Reader logo" title="AO3 Reader" className="h-9 w-9 object-contain" />
              </span>
              <span className="font-heading text-lg font-semibold">{t("brand.name")}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-50/75 dark:text-foreground-950/75">{t("footer.desc")}</p>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold">{t("footer.navTitle")}</h3>
            <nav className="mt-4 grid gap-2">
              {ao3NavItems.map((item) => (
                <a
                  key={item.id}
                  href={`#${item.target}`}
                  onClick={(e) => go(e, item.target)}
                  className="w-fit cursor-pointer text-sm text-background-50/75 transition-colors hover:text-background-50 dark:text-foreground-950/75 dark:hover:text-foreground-950"
                >
                  {t(`nav.${item.id}`)}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold">{t("footer.contactTitle")}</h3>
            <p className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-background-50 dark:text-foreground-950">
              <i className="ri-mail-line text-lg leading-none text-accent-200 dark:text-accent-700" />
              {config.contactEmail}
            </p>
          </div>
        </div>

        <div className="mt-10 border-t border-background-50/20 pt-6 dark:border-foreground-950/20">
          <p className="text-xs text-background-50/70 dark:text-foreground-950/70">
            © {new Date().getFullYear()} {t("brand.name")}. {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}